import { State } from "./types";

const initialState: State = {
  queue: [],
};

export { initialState };
